import Vue from "vue";
import ShoppingCartContainer from "./model/ShoppingCartContainer";

class Framework extends EventTarget {
  constructor() {
    super();

    this.state = Vue.observable({
      open: false,
      container: null,
    });

    this.init();

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        this.unload();
      } else {
        this.init();
      }
    });

    window.addEventListener("storage", this.init());

    window.addEventListener("unload", this.unload);
  }

  init() {
    const shoppingCartContainerItems = localStorage.getItem(
      "shoppingCartContainerItems"
    );

    this.state.container = new ShoppingCartContainer(
      shoppingCartContainerItems ? JSON.parse(shoppingCartContainerItems) : []
    );
  }

  unload() {
    localStorage.setItem(
      "shoppingCartContainerItems",
      JSON.stringify(
        this.container.items.map(({ state }) => state).filter((item) => !!item)
      )
    );
  }

  get container() {
    return this.state.container;
  }

  toggle() {
    this.state.open = !this.state.open;
  }

  get open() {
    return this.state.open;
  }

  set open(v) {
    this.state.open = v;
  }
}

export default Framework;
